<template>
  <div class="module_exemplary-data">
    <h3>{{ $t("shop_personalisierbar") }}</h3>
    <div>
      <div class="exemplartexte-list" :key="text.NameImEntwurf" v-for="(text, index) in product.editableTextGroups">
        <div class="exemplartexte-part">{{ getPartname(index) }}</div>
        <label class="exemplartexte-label">
          <input class="exemplartexte-value" type="text" name="Textvalue" v-model="text.value" id="textValueID" >
          <span>{{ text.Inhalt }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExemplaryData",
  props: {
    product: Object
  },
  setup(props){
    const i18n = useI18n();

    function isSingleNumberText(inhalt){
      if(isNaN(inhalt)){
        return false;
      }

      return props.product.editableTextGroups.filter((ele)=>{if(!isNaN(ele.Inhalt)){return ele;}}).length===1;
    }

    function isSingleTextText(inhalt){
      if(!isNaN(inhalt)){
        return false;
      }

      return props.product.editableTextGroups.filter((ele)=>{if(isNaN(ele.Inhalt)){return ele;}}).length===1;
    }

    function getPartname (index){
      const inhalt = props.product.editableTextGroups[index].Inhalt;

      if(isSingleNumberText(inhalt)){
        return i18n.t("konf_nummer");
      }
      else if(isSingleTextText(inhalt)){
        return i18n.t("konf_Exemplarliste_Text");
      }
      else{
        const Partnames = props.product.editableTexts.filter((ele)=>ele.Inhalt === inhalt).map((ele)=>i18n.t("shop_label_"+ele.Part));
        return Partnames.join(', ');
      }
    }

    return {
      getPartname
    }
  }
}
</script>

<style lang="scss" scoped>
@use "~/assets/scss/settings/_config.scss" as *;
.module_exemplary-data {
  h3 {
    font-weight: 600;
  }
}

.team-product-select {
  width: 100%;
  margin-bottom: 15px;
}

.exemplartexte-list {
  width: 900px;
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
  width: 400px;
}

.exemplartexte-part {
  width: 50%;
  padding-top: 5px;
}

.exemplartexte-inhalt {
  width: 20%;
  padding-top: 5px;
}

.exemplartexte-label {
  position: relative;
  display: flex;
  flex-direction: column;

  span{
    position:absolute;
    top: 0px;
    left: 10px;
    //transform:translateY(15px);
    font-size: 11px;
    transition-duration:300ms;
    font-weight: 400;
    color: #8D8D8D;
  }
}

.exemplartexte-value {
  //width: calc(50% - 15px);
  border: 1px solid $color-grey;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 40px;
  cursor: pointer;
  padding-left: 10px;
  padding-top: 10px;

  &::placeholder {
    opacity: 0;
  }
}

.error {
  color: $color-red;
  font-size: 12px;
  display: block;
  line-height: 16px;
}

</style>
